import type { IntlShape } from 'react-intl';
import realTimeTrailConditions from '../UpsellFeatureList/realTimeTrailConditions';
import unlimitedMapDownloads from '../UpsellFeatureList/unlimitedMapDownloads';
import wrongTurnAlerts from '../UpsellFeatureList/wrongTurnAlerts';

const plusFeatures = (intl: IntlShape) => [unlimitedMapDownloads(intl), realTimeTrailConditions(intl), wrongTurnAlerts(intl)];

export default plusFeatures;
